import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, {
  createRef,
  Fragment,
  FunctionComponent,
  useEffect,
  useState,
} from "react";
import { useSearchParams } from "react-router-dom";
import {
  IDistributorMaster,
  IDistributorMasterProps,
} from "./IDistributorMaster";
import {
  Autocomplete,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import TextFiealdInput from "../components/textFiald";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/Hooks";
import {
  clearCreateDistributorMaster,
  createDistributorMasterStart,
} from "../../redux/distributor-master/createDistributorMaster";
import {
  clearEditDistributorMaster,
  editDistributorMasterStart,
} from "../../redux/distributor-master/editDistributorMaster";
import CompletePopup from "../components/response-pop-up";
import AutoComplete from "../components/autocomplete-input";
import { Button } from "react-bootstrap";

const DistributorMasterForm: FunctionComponent<IDistributorMasterProps> = (
  props
) => {
  const { handleClose, setInitialValues, initialValues } = props;
  const [isEdit, setEdit] = useState<boolean>(false);

  const fileRep = createRef<any>();
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();

  // const { data: listDistributor, isLoading: listDistributorLoading } = useAppSelector(
  //   (state: any) => state.ListDistributorMaster
  // );

  const stateOpetionList: any = useAppSelector((state) => state.GeneralSetting);

  const { isLoading: createDistributorLoading, data: createDistributor } =
    useAppSelector((state) => state.CreateDistributorMaster);

  const { isLoading: editDistributorLoading, data: editDistributor } =
    useAppSelector((state) => state.EditDistributorMaster);

  const state_option = stateOpetionList?.data?.result
    .filter((e: any) => {
      if (e.page === "state") {
        return e;
      }
    })
    .map((e: any) => {
      const data = { label: e.description, value: e.name };
      return data;
    });

  const distributor_option = stateOpetionList?.data?.result
    .filter((e: any) => {
      if (e.page === "Distributor Master Type") {
        return e;
      }
    })
    .map((e: any) => {
      const data = { label: e.description, value: e.name };
      return data;
    });

  console.log("Distributor option", distributor_option);

  //   validation
  const validationSchema = Yup.object().shape({
    id: Yup.number().optional(),
    name: Yup.string()
      .max(50, "maximum 50 character")
      .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
      .required("Distributor Name Required"),

    code: Yup.string().required("Code Number Required"),
    city: Yup.string()
      .max(100, "maximum 100 character")
      .required("City Required")
      .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field "),
    state: Yup.string().required("State Required"),

    email: Yup.string()
      .email("email is invalid")
      .max(100, "maximum 100 character")
      .required("Email Required"),

    active: Yup.boolean().optional(),
  });

  const formik = useFormik<IDistributorMaster>({
    enableReinitialize: true,
    initialValues: {
      name: "",
      type: "",
      city: "",

      state: "",
      email: "",

      code: "",
      active: initialValues.active ? initialValues.active : true,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log(values);

      submit(values);
    },
  });
  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    setFieldValue,
    setFieldTouched,
    resetForm,
    errors,
    setValues,
    validateForm,
  } = formik;

  console.log(touched);

  const submit = (a: IDistributorMaster) => {
    // console.log("datas", a);

    if (a.id) {
      dispatch(editDistributorMasterStart(a));
    } else {
      dispatch(createDistributorMasterStart(a));
    }
  };

  useEffect(() => {
    if (initialValues?.id) {
      setValues(initialValues);
    }
    return () => {
      setInitialValues({});
    };
  }, []);

  return (
    <Fragment>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <Grid container rowSpacing={3} columnSpacing={3}>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <TextFiealdInput
                name="name"
                label="Distributor Name"
                handleChange={handleChange}
                handleBlur={handleBlur}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <div className="field_item">
                <label className="f4">
                  Distributor Type <span>*</span>
                </label>
                <Autocomplete
                  className="custom_autocomplete"
                  renderOption={(
                    props: React.HTMLAttributes<HTMLLIElement>,
                    option: any
                  ) => {
                    return (
                      <li {...props} key={option.value}>
                        {option.label}
                      </li>
                    );
                  }}
                  value={
                    distributor_option.find((e: any) => {
                      return e.value === values.type;
                    }) ?? null
                  }
                  options={distributor_option}
                  onChange={(e, value: any) => {
                    const a = value ? value.value : "";
                    setFieldValue("type", a);
                  }}
                  renderInput={(params) => (
                    <TextField
                      sx={{
                        textTransform: "capitalize",
                      }}
                      onBlur={handleBlur}
                      error={touched.type && errors.type ? true : false}
                      helperText={
                        touched.type && errors.type ? errors.type : ""
                      }
                      name="type"
                      placeholder="Select Retailer Type"
                      {...params}
                    />
                  )}
                />
              </div>
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <TextFiealdInput
                name="email"
                label="Email"
                handleChange={handleChange}
                handleBlur={handleBlur}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <TextFiealdInput
                name="city"
                label="City"
                handleChange={handleChange}
                handleBlur={handleBlur}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <div className="field_item">
                <label className="f4">
                  State <span style={{ marginLeft: "3px" }}>*</span>
                </label>
                <Autocomplete
                  className="custom_autocomplete"
                  renderOption={(
                    props: React.HTMLAttributes<HTMLLIElement>,
                    option: any
                  ) => {
                    return (
                      <li {...props} key={option.value}>
                        {option.label}
                      </li>
                    );
                  }}
                  value={
                    state_option.find((e: any) => {
                      return e.value === values.state;
                    }) ?? null
                  }
                  options={state_option}
                  onChange={(e, value: any) => {
                    const a = value ? value.value : "";
                    setFieldValue("state", a);
                  }}
                  renderInput={(params) => (
                    <TextField
                      sx={{
                        textTransform: "capitalize",
                      }}
                      onBlur={handleBlur}
                      error={touched.state && errors.state ? true : false}
                      helperText={
                        touched.state && errors.state ? errors.state : ""
                      }
                      name="state"
                      placeholder="Select State"
                      {...params}
                    />
                  )}
                />
              </div>
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <TextFiealdInput
                name="code"
                label="Code"
                handleChange={handleChange}
                handleBlur={handleBlur}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <div className="field_name">
                <FormControlLabel
                  value={values.active}
                  control={<Checkbox checked={values.active} />}
                  label="Is Active"
                  onChange={(_, val) => {
                    setFieldValue("active", val);
                  }}
                  name="active"
                  labelPlacement="end"
                />
              </div>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions>
        <div className="dialog_footer">
          <Button
            onClick={() => {
              handleClose();
              setEdit(false);
            }}
            className="common_btn_outline"
          >
            Cancel
          </Button>

          <Button
            className="common_btn"
            onClick={() => {
              handleSubmit();
              validateForm();
            }}
          >
            {createDistributorLoading || editDistributorLoading
              ? "Please Wait..."
              : "Save"}
          </Button>
        </div>
      </DialogActions>
    </Fragment>
  );
};

export default DistributorMasterForm;
